import security from './security';

import media from '../images/objectives/media.jpg';
import homesecurity from '../images/objectives/homesecurity.jpg';
import helpme from '../images/objectives/helpme.jpg';
import objective from '../images/objectives/objective.jpg';

const OBJECTIVES = {
    MEDIA_ENTERTAINMENT: 'Media & Entertainment',
    HOME_SECURITY: 'Home Security',
    HELP_DECIDE: 'Help me decide',
};

const start = {
    group: 'objectives',
    name: 'start',
    question: 'What is your primary smart home objective?',
    description: 'With your home, you have a lot of things that can be made "smart". What is your primary goal? You can always come back and select a different objective later.',
    image: objective,
    type: 'detailed',
    optionsText: 'Select an option',
    options: () => [
        {
            label: 'Media & Entertainment',
            description: 'Control music, television, lights, and other entertainment devices from your Amazon Echo device or phone.',
            value: OBJECTIVES.MEDIA_ENTERTAINMENT,
            disabled: true,
            image: media,
            queue: [],
        },
        {
            label: 'Home Security',
            description: 'Secure your home, control access, see, record, and be alerted of changes about and around your home from anywhere.',
            value: OBJECTIVES.HOME_SECURITY,
            image: homesecurity,
            queue: [security.start],
        },
        {
            label: 'Help me decide',
            description: 'Not quite sure what you need? We can help you figure it out.',
            value: OBJECTIVES.HELP_DECIDE,
            disabled: true,
            image: helpme,
            queue: [],
        },
    ],
    onSelect: (selection, questions) => {
        if(!selection.queue)
            return null;

        selection.queue.forEach((question) => {
            if(questions.indexOf(question) === -1)
                questions.push(question);
        });

        return selection.value;
    },
};

export default {
    start,
};
